export default {
  phone: "613-445-9876",
  fullAddress: "44 Mt Hope Rd, Petawawa, ON K8H 3P1",
  email: "mytransitioncontact@email.ca",
  preferredLanguageWritten: "English",
  preferredLanguageSpoken: "English",
  emailNotifications: "On",
  notifyAboutTA: true,
};
